import request from '@/utils/request'

/**
 * 获取职位列表
 */
export function getPositionList (category, property, pageNum) {
  return request({
    url: '/apply/jobs',
    method: 'get',
    params: {
      category,
      property,
      pageNum,
      pageSize: 20
    }
  })
}

/**
 * 获取职位分类
 */
export function getPositionCategory (recruitmentCategory) {
  return request({
    url: '/apply/job/category',
    method: 'get',
    params: { 'recruitmentCategory': recruitmentCategory }
  })
}

/**
 * 获取职位详情
 */
export function getPositionDetail (jobCode) {
  return request({
    url: `/apply/job/details?jobCode=${jobCode}`,
    method: 'get',
    data: jobCode
  })
}

/**
 * 搜索职位
 */
export function searchPosition (position, category, property, pageNum) {
  return request({
    url: '/apply/job',
    method: 'get',
    params: {
      position,
      category,
      property,
      pageNum,
      pageSize: 20
    }
  })
}
